(function(angular){
	'use strict';
	
	var activeProjectsPieChartObject = {
		templateUrl: ['STATIC_BASE_PATH', templateUrlFunction],
		bindings: {
			projects: '<',
			theme: '@'
		},
		controller: [
			'$filter',
			'$rootScope',
			'ReitElementTooltipFactory',
			ActiveProjectsPieChartFunction
		],
		controllerAs: 'activeProjectsPieChart'
	};
	
	angular
		.module('productPage')
		.component('activeProjectsPieChart', activeProjectsPieChartObject);
	
	function templateUrlFunction(STATIC_BASE_PATH) {
		return STATIC_BASE_PATH + '/static/html/reits/product-pages/active-projects-pie-chart.html';
	}
	
	function ActiveProjectsPieChartFunction(
		$filter,
		$rootScope,
		ReitElementTooltipFactory){
		var activeProjectsPieChart = this;

		activeProjectsPieChart.$onInit = function() {

			var data = [];

			if(!angular.isDefined(activeProjectsPieChart.theme)) {
				activeProjectsPieChart.theme = 'light';
			}

			activeProjectsPieChart.chartOptions = {
				chart: {
					type: 'pie',
					spacing: [0,0,0,0]
				},
				plotOptions: {
					pie: {
						borderColor: activeProjectsPieChart.theme === 'dark' ? '#004080' : '#ffffff'
					}
				},
				series: []
			};

			if(activeProjectsPieChart.projects.length > 0) {

				angular.forEach(activeProjectsPieChart.projects, function(project) {

					data.push({
						color: project.rating.color,
						rating: project.rating.full,
						y: Number(project.totalSize),
						reitElement: project
					});
				});

				data = $filter('orderBy')(data,'rating');

				angular.extend(activeProjectsPieChart.chartOptions, {
					series: [{
						cursor: 'pointer',
						data: data,
						point: {
							events: {
								click: function() {
									$rootScope.ModalFactory.openReitElement({
										reitElement: this.reitElement
									});
								}
							}
						},
						states: {
							hover: {
								enabled: true
							}
						}
					}],
					tooltip: {
						enabled: true,
						useHTML: true,
						padding: 0,
						borderWidth: 0,
						backgroundColor: 'transparent',
						formatter: function() {
							var tooltip;
							tooltip = ReitElementTooltipFactory.buildReitElementTooltip(this.point.reitElement);
							return tooltip;
						},
						hideDelay: 100,
						positioner: function(labelWidth, labelHeight, point) {
							return { x: point.plotX - (labelWidth / 2), y: point.plotY - labelHeight - 16 };
						},
						shadow: false
					}
				});
			
			} else {

				angular.extend(activeProjectsPieChart.chartOptions, {
					series: [{
						data: [{
							y: 1,
							color: '#e3e6e8'
						}]
					}]
				});
			}
		};
	}
})(window.angular);